import * as React from 'react'

export function DataTableTitle({ children }: { children?: React.ReactNode }) {
  return <div className="text-primary text-[20px] font-medium">{children}</div>
}

